import { Locale } from './getLocale';

// We enumerate all dictionaries here for better linting and typescript support
// We also get the default import for cleaner types
const dictionaries = {
  en: () => import('./en.json').then(module => module.default),
  es: () => import('./es.json').then(module => module.default),
};

export const getDictionary = (locale: Locale) => dictionaries[locale]();

export type Lang = Awaited<ReturnType<typeof getDictionary>>;
